import React from "react";
import Img from "./img";
import Link from "@/components/link";
import { navigate } from '@reach/router';
// const isBrowser = typeof window !== "undefined"

const BlogPost = ({ post, noTags, details, nextPost, prevPost}) => {
  const { image, date, title, url, text, tags, body } = post;

  return (
    <>
      <div className={`d-flex flex-column blog_left_box ${!details ? 'blog_left_box_small  border p-3':''}`}>
        <div className={`bl_share_img ${!!details ? 'box-img-big' : ''}`} >
          {!details ?
            <Link href={url}> <Img src={image} alt="blog details" className={`img-fluid ${!!details ? 'img-big' : ''}`} /> </Link>
            :
            <Img src={image} alt="blog details" className={`img-fluid ${!!details ? 'img-big' : ''}`} />

        }
          <span className="blog_date">{date}</span>
        </div>
        <div className="blog_share_details blog_share_details__details">

          <h1>
            <Link href={url}>{title}</Link>
          </h1>
          {!!details ? 
            <p dangerouslySetInnerHTML={{ __html: body }} >
            </p>
            :
             <p>{String(text).length < 100 ? text : String(text).slice(0, 100).slice(0, String(text).slice(0, 100).lastIndexOf(" ")) + ' (...)'}</p>
          }

        </div>
        {!details &&
          <div className="d-flex px-3 mt-auto justify-content-end w-100 links-style">
            <Link href={url}>LEER MÁS</Link>
          </div> }
        {!!details &&
          <>
          <div className='d-flex mx-3 mb-3 inverted_hover'>
            <a style={{visibility:!!prevPost?'visible':'hidden'}} className='me-auto inverted' href={`/novedades/${(prevPost?.pk)}`} >{'< '}Anterior</a>     
            <a className="showOnDesktop mx-auto mb-3 btn-yellow" href={`/blog`}>VER TODAS LAS NOVEDADES</a>
            <a style={{ visibility: !!nextPost?'visible':'hidden' }} className='ms-auto inverted' href={`/novedades/${(nextPost?.pk)}`} >Siguiente{' >'}</a> 
          </div>
          <a className="showOnMobile mx-auto mb-3 btn-yellow" href={`/blog`}>VER TODAS LAS NOVEDADES</a>
          </>   
        }
      
      {!noTags &&
      <div className="blog_social_share_box">
        <div className="share_box_left">
          <p >
            {tags?.map((tag) =>   
              <span key={`tag-${tag}`} onKeyDown={()=>null} role='button' tabIndex={0} className='border rounded-pill px-3 mx-1 mb-2' onClick={() => { navigate(`/blog?searchTag=${tag}`)}} > {tag}</span>         
            )}
          </p>
        </div>
      </div>
      }
      </div>
    </>
  );
};

export default BlogPost;
